const ARTICLES_DATA = {
    articles: [
        {
            title: "The Importance of Cancer Screening",
            sectionHeader1: "Bladder Cancer",
            url: "the-importance-of-prostate-cancer-screening",
            author: '',
            company:'',
            body: `
                    <p>Although it seems like it should make cancer seem less frightening, cancer screening sometimes can
                        make things seem even more intimidating. Patients often hear different opinions on certain cancer
                        screenings and are often unsure if they are doing all that they can do to detect cancer early.</p>
                    <p>With prostate cancer, the guidelines and screening protocols seem to be ever-changing. While this
                        means that more knowledge about the disease is being obtained (which is a good thing), it also makes
                        it difficult for patients and even doctors to stay up to date (not so good). This is especially true
                        when it comes to the use of Prostate Specific Antigen, known widely as “PSA.”</p>
                    <p>PSA is a protein released by the prostate gland into the blood stream. An abnormally high PSA level
                        may indicate prostate cancer. However, it can also be elevated because of non-cancerous causes such
                        as prostatitis or an enlarged prostate. It is also common for PSA to gradually become more elevated
                        as men get older. Therefore, unlike most labs, there is not a clear cut “normal range.” You must
                        include multiple factors such as patient age and other health history to decide if a PSA level is a
                        concern regarding possible prostate cancer.</p>
                    <p>PSA has been used for prostate cancer screening since 1994. Although widely used, urologists early
                        on were still trying to figure out which patient populations it most benefitted and the ranges where
                        the PSA level should be considered as “high” or “normal.”</p>
                    <p>Fortunately, with the encouragement of multiple health agencies including the American Urologic
                        Association, the United States Preventive Services Task Force (USPSTF), an independent volunteer
                        group of experts in prevention and evidence-based medicine, reviewed research and realized that PSA
                        screening could be very beneficial in certain demographics. They recommend screening for men ages 55
                        - 69. They also felt that African American men and men with a family history of prostate cancer are
                        at an increased risk of developing prostate cancer and should discuss the possibility of even
                        earlier PSA screening.</p>
                    <p>PSA screening is just the beginning. When PSA is elevated you must make the decision of whether you
                        want to do a prostate biopsy. Depending on how aggressive the disease looks under the microscope you
                        may be able to simply keep an eye on it, while on the opposite spectrum you may get results that
                        confirm the cancer is aggressive and may have already spread.</p>
                    <p>Nothing about prostate cancer is straightforward. Shared decision making is important throughout the
                        entire process. We do feel that from a PSA screening standpoint, all men in their 50s and 60s should
                        be getting annual screening. If you are extremely healthy you may continue screening into your 70s.
                        If you are at higher risk you may consider as early as age 45. The digital rectal exam (DRE) should
                        be utilized as a supplement to PSA screening, especially in equivocal cases looking for nodules.</p>
                    <p>At the end of the day, we hope to screen the appropriate people and treat the appropriate people to
                        prevent advanced metastatic disease that is lethal. We feel that if patients and doctors stick to
                        the newest recommended guidelines that the number of men dying of advance prostate cancer will
                        decrease significantly. That is why until an even better test comes along, we strongly advocate for
                        appropriate PSA screening.</p>`,
            id: 1
        },
        {

            title: "Kidney Stones and Desert Climate",
            sectionHeader1: "Bladder Cancer",
            url: "kidney-stones-and-desert-climate",
            author: 'Dr. Sarah Ryan, M.D.',
            company: 'Urology Specialists of Nevada',
            body: `<p>Hydration, hydration, hydration - remember when people simply just said, "drink plenty of water?"</p>

                <p>Whatever name you give to it, there is good reason for the advice, especially here in the desert
                    Southwest. If you draw a line along the Southern states, this area is often referred to in the
                    medical profession as the ‘Stone Belt’ because of the hot climates where dehydration is common.</p>

                <p>Of course, there are many reasons for kidney stones beyond dehydration. If you've had kidney stones,
                    you know what they are and how they feel. If you haven't been diagnosed before, there are signs to
                    watch out for. But for the (fortunately) uninitiated . . .
                </p>

                <p class="bold">What are kidney stones (besides painful)?</p>

                <p>Kidney stones are small, hard deposits that form inside your kidneys. The stones are made of mineral
                    and acid salts. They can have many causes and can affect any part of your urinary tract from your
                    kidneys to your bladder.</p>

                <p>Passing stones can be very painful, but they usually cause no permanent damage. In some instances,
                    however, stones can become lodged in the urinary tract or cause other complications and require
                    surgery.
                </p>

                <p class="bold">Signs of a problem
                </p>

                <p>You may not experience any symptoms until a stone moves around within your kidney or passes into your
                    ureter (the tube connecting the kidney and bladder). If that happens, you may experience one or more
                    of the following signs and symptoms:</p>
                <ul>
                    <li>A persistent need to urinate</li>
                    <li>Cloudy or foul-smelling urine</li>
                    <li>Fever and chills (if an infection is present)</li>
                    <li>Nausea and vomiting</li>
                    <li>Pain when urinating</li>
                    <li>Severe pain in your sides and back, below the ribs</li>
                    <li>Pain that spreads to your lower abdomen and groin</li>
                    <li>Pain that comes in waves and fluctuates in intensity</li>
                    <li>Pink, red or brown urine</li>
                    <li>Urinating more often than usual</li>
                    <li>Urinating small amounts of urine</li>
                </ul>
                <p>You should seek immediate medical attention if you experience:</p>
                <ul>
                    <li>Blood in your urine</li>
                    <li>Difficulty passing urine</li>
                    <li>Pain so severe that you can't sit still or find a comfortable position</li>
                    <li>Pain accompanied by nausea and vomiting</li>
                    <li>Pain accompanied by fever and chills</li>
                </ul>
                <p class="bold">But why?</p>
                <p>Kidney stones often have no definite, single cause, although there are several factors that can
                    increase your risk:
                </p>
                <p><b>Dehydration.</b> Not drinking enough water each day can increase your risk of kidney stones and
                    people
                    who live in warm climates (like here in Southern Nevada) and those who sweat a lot (e.g., manual
                    labor, especially outdoors) may be at higher risk.
                </p>
                <p><b>Diet.</b> A diet high in protein, sodium and sugar may increase your risk of some types of kidney
                    stones.
                </p>
                <p><b>Digestive diseases and surgery.</b> Chronic diarrhea, inflammatory bowel disease or gastric bypass
                    surgery can cause changes in digestion that increase the levels of stone-forming substances in your
                    urine.
                </p>
                <p><b>Family or personal history.</b> If someone in your family has kidney stones, you're more likely to
                    develop stones. And if you've already had one or more kidney stones, you're at increased risk of
                    developing them again.
                </p>
                <p><b>Obesity.</b> A high body mass index (BMI), large waist size and weight gain have been linked to an
                    increased risk of kidney stones.
                </p>
                <p> Your family doctor can usually treat small kidney stones that don’t block your kidney or cause
                    other problems. But if you have a large kidney stone and experience severe pain or kidney problems,
                    your doctor may refer you to a urologist - a doctor who treats problems in the urinary tract.
                </p>`,
            id: 2
        },
        {

            title: "Bladder Issues and the Importance of Seeing a Urologist.",
            sectionHeader1: "Bladder Cancer",
            url: "bladder-issues-and-the-importance-of-seeing-a-urologist",
            author: 'Dr. Sarah Ryan, M.D.',
            company: 'Urology Specialists of Nevada',
            body: `<p>Hydration, hydration, hydration - remember when people simply just said, "drink plenty of water?"</p>

                <p>Whatever name you give to it, there is good reason for the advice, especially here in the desert
                    Southwest. If you draw a line along the Southern states, this area is often referred to in the
                    medical profession as the ‘Stone Belt’ because of the hot climates where dehydration is common.</p>

                <p>Of course, there are many reasons for kidney stones beyond dehydration. If you've had kidney stones,
                    you know what they are and how they feel. If you haven't been diagnosed before, there are signs to
                    watch out for. But for the (fortunately) uninitiated . . .
                </p>

                <p class="bold">What are kidney stones (besides painful)?</p>

                <p>Kidney stones are small, hard deposits that form inside your kidneys. The stones are made of mineral
                    and acid salts. They can have many causes and can affect any part of your urinary tract from your
                    kidneys to your bladder.</p>

                <p>Passing stones can be very painful, but they usually cause no permanent damage. In some instances,
                    however, stones can become lodged in the urinary tract or cause other complications and require
                    surgery.
                </p>

                <p class="bold">Signs of a problem
                </p>

                <p>You may not experience any symptoms until a stone moves around within your kidney or passes into your
                    ureter (the tube connecting the kidney and bladder). If that happens, you may experience one or more
                    of the following signs and symptoms:</p>
                <ul>
                    <li>A persistent need to urinate</li>
                    <li>Cloudy or foul-smelling urine</li>
                    <li>Fever and chills (if an infection is present)</li>
                    <li>Nausea and vomiting</li>
                    <li>Pain when urinating</li>
                    <li>Severe pain in your sides and back, below the ribs</li>
                    <li>Pain that spreads to your lower abdomen and groin</li>
                    <li>Pain that comes in waves and fluctuates in intensity</li>
                    <li>Pink, red or brown urine</li>
                    <li>Urinating more often than usual</li>
                    <li>Urinating small amounts of urine</li>
                </ul>
                <p>You should seek immediate medical attention if you experience:</p>
                <ul>
                    <li>Blood in your urine</li>
                    <li>Difficulty passing urine</li>
                    <li>Pain so severe that you can't sit still or find a comfortable position</li>
                    <li>Pain accompanied by nausea and vomiting</li>
                    <li>Pain accompanied by fever and chills</li>
                </ul>
                <p class="bold">But why?</p>
                <p>Kidney stones often have no definite, single cause, although there are several factors that can
                    increase your risk:
                </p>
                <p><b>Dehydration.</b> Not drinking enough water each day can increase your risk of kidney stones and
                    people
                    who live in warm climates (like here in Southern Nevada) and those who sweat a lot (e.g., manual
                    labor, especially outdoors) may be at higher risk.
                </p>
                <p><b>Diet.</b> A diet high in protein, sodium and sugar may increase your risk of some types of kidney
                    stones.
                </p>
                <p><b>Digestive diseases and surgery.</b> Chronic diarrhea, inflammatory bowel disease or gastric bypass
                    surgery can cause changes in digestion that increase the levels of stone-forming substances in your
                    urine.
                </p>
                <p><b>Family or personal history.</b> If someone in your family has kidney stones, you're more likely to
                    develop stones. And if you've already had one or more kidney stones, you're at increased risk of
                    developing them again.
                </p>
                <p><b>Obesity.</b> A high body mass index (BMI), large waist size and weight gain have been linked to an
                    increased risk of kidney stones.
                </p>
                <p> Your family doctor can usually treat small kidney stones that don’t block your kidney or cause
                    other problems. But if you have a large kidney stone and experience severe pain or kidney problems,
                    your doctor may refer you to a urologist - a doctor who treats problems in the urinary tract.
                </p>`,
            id: 3
        }
    ]
}

export default ARTICLES_DATA;
